import React from "react";
import {Link} from "gatsby";

export default function OurHiringModels({post}) {

    return (
        <section className="py-3">
            <div className="container">
                <div className="row align-items-center">
                    <div
                        className="col-lg-5 md-mb-30px"
                        data-anime='{ "el": "childs", "translateX": [15, 0], "opacity": [0,1], "duration": 600, "delay": 100, "staggervalue": 300, "easing": "easeOutQuad" }'
                    >
                        <h3 className="text-dark-gray fw-600 ls-minus-2px">
                            Our Hiring Models
                        </h3>
                        <p className="w-90 md-w-100">
                            Hire Dedicated {post} team at your flexibility.
                        </p>
                        <Link
                            to="/expertise"
                            className="btn btn-large btn-expand-ltr text-dark-gray btn-rounded fw-700"
                        >
                            <span className="bg-base-color" />
                            See what we do
                        </Link>
                    </div>
                    <div className="col-xl-6 col-lg-7 offset-xl-1">
                        <div
                            className="row row-cols-auto row-cols-sm-2"
                            data-anime='{ "el": "childs", "translateX": [50, 0], "opacity": [0,1], "duration": 600, "delay":300, "staggervalue": 150, "easing": "easeOutQuad" }'
                        >
                            <div className="col align-self-start">
                                <div className="feature-box text-start ps-30px">
                                    <div className="feature-box-icon position-absolute left-0px top-10px">
                                        <h1 className="fs-85 text-outline text-outline-width-1px text-outline-color-dark-gray fw-700 ls-minus-1px opacity-2 mb-0">
                                            01
                                        </h1>
                                    </div>
                                    <div className="feature-box-content last-paragraph-no-margin pt-25 md-pt-17 sm-pt-40px">
                                      <span className="text-dark-gray fs-19 d-inline-block fw-600 mb-5px">
                                        Full Time Monthly Hire
                                      </span>
                                        <div className="d-inline-flex gap-2 w-100">
                                            <span className="text-dark-gray fs-15 fw-600">8</span>
                                            <p className="text-dark-gray-hover fs-15">Hours Per Day</p>
                                        </div>
                                        <div className="d-inline-flex gap-2 w-100">
                                            <span className="text-dark-gray fs-15 fw-600">160</span>
                                            <p className="text-dark-gray-hover fs-15">Hours</p>
                                        </div>
                                        <span className="w-40px h-3px bg-base-color d-inline-block" />
                                    </div>
                                </div>
                            </div>
                            <div className="col align-self-end mt-20 xs-mt-15px">
                                <div className="feature-box text-start ps-30px">
                                    <div className="feature-box-icon position-absolute left-0px top-10px">
                                        <h1 className="fs-85 text-outline text-outline-width-1px text-outline-color-dark-gray fw-700 ls-minus-1px opacity-2 mb-0">
                                            02
                                        </h1>
                                    </div>
                                    <div className="feature-box-content last-paragraph-no-margin pt-25 md-pt-17 sm-pt-40px">
                                        <span className="text-dark-gray fs-20 d-inline-block fw-600 mb-5px">
                                            Part Time Monthly Hire
                                        </span>
                                        <div className="d-inline-flex gap-2 w-100">
                                            <span className="text-dark-gray fs-15 fw-600">4</span>
                                            <p className="text-dark-gray-hover fs-15">Hours Per Day</p>
                                        </div>
                                        <div className="d-inline-flex gap-2 w-100">
                                            <span className="text-dark-gray fs-15 fw-600">80</span>
                                            <p className="text-dark-gray-hover fs-15">Hours</p>
                                        </div>
                                        <span className="w-40px h-3px bg-base-color d-inline-block" />
                                    </div>
                                </div>
                            </div>
                            <div className="col align-self-start mt-minus-12 xs-mt-15px">
                                <div className="feature-box text-start ps-30px">
                                    <div className="feature-box-icon position-absolute left-0px top-10px">
                                        <h1 className="fs-85 text-outline text-outline-width-1px text-outline-color-dark-gray fw-700 ls-minus-1px opacity-2 mb-0">
                                            03
                                        </h1>
                                    </div>
                                    <div className="feature-box-content last-paragraph-no-margin pt-25 md-pt-17 sm-pt-40px">
                                        <span className="text-dark-gray fs-20 d-inline-block fw-600 mb-5px">
                                            Hourly Hire
                                        </span>
                                        <div className="d-inline-flex gap-2 w-100">
                                            <span className="text-dark-gray fs-15 fw-600">50/100/200/400</span>
                                            <p className="text-dark-gray-hover fs-15">Hours</p>
                                        </div>
                                        <div className="text-dark-gray fs-15 d-inline-block fw-600 mb-5px w-100">
                                            Flexible Maintenance Service
                                        </div>
                                        <span className="w-40px h-3px bg-base-color d-inline-block" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}